const { DEFAULT_LANGUAGE } = require('../brandFeatures.json');

module.exports = {
  name: 'verticalDetector',

  lookup({ res }) {
    const { locals } = res;
    if (locals && locals.vertical && DEFAULT_LANGUAGE[locals.vertical]) {
      return DEFAULT_LANGUAGE[locals.vertical];
    }
    return DEFAULT_LANGUAGE.default;
  },
};
